
import { BlogPost, FAQItem, Lead, GalleryImage, NewsletterSubscriber } from '../types';

const KEYS = {
  BLOGS: 'stealth_blogs',
  FAQS: 'stealth_faqs',
  TAGS: 'stealth_tags',
  LEADS: 'stealth_leads',
  GALLERY: 'stealth_gallery',
  SUBSCRIBERS: 'stealth_subscribers',
  GOOGLE_KEY: 'stealth_google_api_key'
};

const gDrive = (id: string) => `https://lh3.googleusercontent.com/d/${id}`;

// Нові ID від користувача
const PHOTO_IDS = [
  '1wxdsAb7It-WCBCQhE8exlAzz8NFtM03L', '1KbioY4qsiaRvlMJGj-WN7ZoVFwSxWH8X', '1GkMnK3O4dfqG95aXpudQ-gqfVAWqpUL8', 
  '1OOUOfMirVTk4bv7CE4LtN90ELFVx6O3W', '1gSXw96x9ibl06oclJuRoy0yHQclIJqJl', '10XmpbYzs2D2_WVr2u6jv0WUs-PHppvh5', 
  '1AJus49dSMRg_5wp08k9D8raFUh_pGnLx', '1d4gIeNsUkFD6gX1Bxe9Ks-rBFROV0Lh_', '1e3oR0bspU7LrYaPOoXCs6eVidwZD4yws', 
  '1ssDK46ZBgdsz9U74jQv7Xj3XGSjAMXvA', '1c7oAVKBlF-uO7e1N-LbhcBMvUajXm-0C', '1ubtyd5_Z-_pKyoYJydWVL4rnEWgeUsO7', 
  '1ZYwUJvWDHdRD_3zLxMBUNR0BEmLFV7ZS', '1TdZmSF72H4sGXLBZXOfVU2SGcyb55qF2', '1iDcS4y866agBqKTQUx1TDdUQLaKVymRr', 
  '16zSJjmXF0u9tb6ETToQCPBbcdD9As1N2', '1u3rnwIcSovCqdvHvNSNaqg7d1Za8spsu', '1cjrHdBoBrZJAk5ULxzRN9FHBW8dmyRQY', 
  '12BqNJDl2pNRil7oepqfTaLCSUITnTZHN', '1Wkgsxo3RlbNAUVERdpj1h5-XbNUKgej-', '1tGztVFRrZQEGUridMXjkIw3xixy5Ch7p', 
  '16AnmAzOY592t5AOLgFYeY9NQiW0OvLYB', '1rgxF9__OVggVPsBDpi543A9git3nWybS', '1MHy42sCVkUuffsNJ3mqfa4VuBj5dZb_K', 
  '1yTLV3I8tV8gmbuTzurcMMVNl8aaCIggp', '1_rhjOKAogFx4UGvWjyliAlEaD9aSmTDT', '1kpKtTK9ahnf8s497T-OHNzVG9CRjl5Mt', 
  '1dmJsYVK1Ii6Z8kFVWan7FuGumDhXKAS3', '1e7BYh_Lffk417RhAIrM3QyDPlgm4jNOR', '1vMMavbtuFy3QEsmmw-jV0fJMdXjDh9po', 
  '1FvTj2TvNpsS6QVszM9HL5mk-LhZ1Nqwy', '12vmQ8O-2o7c_WeLg2UXUssdyqAUeh16q', '1aKyHXd6Li2uxOg9WiEcpfH4opcFimY23', 
  '1Kt3D0AivObFI7Tdg8RFfeXQZDEF50spj', '1p1t20sIb5qGOz-DXLu2IhpeuaWq6v8YV', '1YUNpJif9VFxhcHVBl-_UpQDK3y14jTke', 
  '1O8-wJdWUIA11xsVm8MJJphdgIycr-3wy', '1mBfVGAaXQTcDRVyvZ2I3f7q3E00JtRHv', '1DLTWAB7WYd9rHw4eRG6Z0z95oCeLvmcj', 
  '1OrzLO2uk6BmOSsqziZbrdA8GHIh26wNY'
];

const INITIAL_BLOGS: BlogPost[] = [
  { 
    id: '1', 
    title: 'Stealth: The Peak of Modular Luxury', 
    excerpt: 'Combining stealth aesthetics with panoramic freedom.', 
    content: 'Stealth modular units redefine what it means to live in nature. With full-height glass walls, these structures disappear into the landscape while providing uncompromising interior comfort...', 
    images: [gDrive('1wxdsAb7It-WCBCQhE8exlAzz8NFtM03L')], 
    date: 'Dec 05, 2024', 
    likes: 312, 
    tags: ['Architecture', 'Lifestyle'], 
    isPopular: true 
  },
  { 
    id: '2', 
    title: 'Maximizing ROI in Czech Glamping', 
    excerpt: 'How our clients achieve 30% annual return.', 
    content: 'The demand for premium glamping in the Czech Republic is skyrocketing. Stealth houses provide the aesthetic appeal that justifies high daily rates and maintains high occupancy year-round...', 
    images: [gDrive('1KbioY4qsiaRvlMJGj-WN7ZoVFwSxWH8X')], 
    date: 'Jan 12, 2025', 
    likes: 184, 
    tags: ['Investment', 'Business'], 
    isPopular: true 
  },
  { 
    id: '3', 
    title: 'Sustainable Living Without Sacrifice', 
    excerpt: 'A++ energy efficiency meets premium design.', 
    content: 'Energy efficiency is at the heart of the Stealth project. Using PIR insulation and high-performance double glazing, we ensure your comfort during harsh winters without high utility bills...', 
    images: [gDrive('1GkMnK3O4dfqG95aXpudQ-gqfVAWqpUL8')], 
    date: 'Feb 10, 2025', 
    likes: 95, 
    tags: ['Eco', 'Maintenance'], 
    isPopular: false 
  },
];

const INITIAL_FAQS: FAQItem[] = [
  { id: '1', question: "Do I need a building permit?", answer: "In many regions of the Czech Republic, mobile modular homes under 25m² fall under simplified regulations. We handle the documentation for you." },
  { id: '2', question: "How long is the warranty?", answer: "We provide a 10-year structural warranty and a 2-year warranty on all finishing materials and equipment." }
];

const INITIAL_GALLERY: GalleryImage[] = PHOTO_IDS.map((id, index) => ({
  id: `g${index}`,
  url: gDrive(id),
  title: `Stealth Interior ${index + 1}`
}));

export class StorageService {
  static getGoogleKey(): string {
    return localStorage.getItem(KEYS.GOOGLE_KEY) || '';
  }

  static saveGoogleKey(key: string) {
    localStorage.setItem(KEYS.GOOGLE_KEY, key);
  }

  static getBlogs(): BlogPost[] {
    const data = localStorage.getItem(KEYS.BLOGS);
    return data ? JSON.parse(data) : INITIAL_BLOGS;
  }

  static saveBlogs(blogs: BlogPost[]) {
    localStorage.setItem(KEYS.BLOGS, JSON.stringify(blogs));
  }

  static getFAQs(): FAQItem[] {
    const data = localStorage.getItem(KEYS.FAQS);
    return data ? JSON.parse(data) : INITIAL_FAQS;
  }

  static saveFAQs(faqs: FAQItem[]) {
    localStorage.setItem(KEYS.FAQS, JSON.stringify(faqs));
  }

  static getTags(): string[] {
    const data = localStorage.getItem(KEYS.TAGS);
    return data ? JSON.parse(data) : ['Investment', 'Glamping', 'Architecture', 'Business', 'Eco'];
  }

  static saveTags(tags: string[]) {
    localStorage.setItem(KEYS.TAGS, JSON.stringify(tags));
  }

  static getGallery(): GalleryImage[] {
    const data = localStorage.getItem(KEYS.GALLERY);
    return data ? JSON.parse(data) : INITIAL_GALLERY;
  }

  static saveGallery(gallery: GalleryImage[]) {
    localStorage.setItem(KEYS.GALLERY, JSON.stringify(gallery));
  }

  static getSubscribers(): NewsletterSubscriber[] {
    const data = localStorage.getItem(KEYS.SUBSCRIBERS);
    return data ? JSON.parse(data) : [];
  }

  static saveSubscribers(subscribers: NewsletterSubscriber[]) {
    localStorage.setItem(KEYS.SUBSCRIBERS, JSON.stringify(subscribers));
  }

  static addSubscriber(email: string) {
    const subs = this.getSubscribers();
    if (!subs.some(s => s.email === email)) {
      subs.push({
        id: Date.now().toString(),
        email,
        timestamp: Date.now()
      });
      this.saveSubscribers(subs);
    }
  }
}
